// extracted by mini-css-extract-plugin
export default {"text":"CgDwajpxnPS4Q4KXE1dg","headline":"K8Xa3e_1Xp0k6cUORlsQ","paragraph":"niZj2XsQj5dxEiVizcO9"};